import Image from 'next/image';
import { IconStar } from '@/icons/IconStar';
import { ITestimonial } from '@/interfaces/homepage';

export function TestimonialCard({ testimonial, children }: Readonly<{ testimonial: ITestimonial; children?: React.ReactNode }>) {
  return (
    <div className="flex h-full flex-col gap-3 border border-gray-800 p-3 text-lg shadow-sm md:flex-row">
      <div className="relative aspect-[5/4] overflow-hidden md:flex-1">
        <Image src={testimonial.ImageUrl} alt={testimonial.ImageUrl || ''} fill className="object-cover" />
      </div>

      <div className="flex flex-1 flex-col items-center justify-center gap-4 p-4 pb-0 text-center lg:mt-10">
        <div className="flex gap-2">
          {[1, 2, 3, 4, 5].map((_, i) => (
            <IconStar key={i} filled={i < testimonial.Ratings} />
          ))}
        </div>

        {/* NOTE: using subtitle as title to avoid backend changes as per feedback */}
        {testimonial.SubTitle ? <p className="text-2xl font-semibold md:text-4xl">"{testimonial.SubTitle}"</p> : <></>}

        <div dangerouslySetInnerHTML={{ __html: testimonial?.Text || '' }} />

        <p className="text-xl font-medium text-gray-800 md:text-2xl">{testimonial.UserName || ''}</p>

        <div className="my-2 md:my-6">{children}</div>
      </div>
    </div>
  );
}
